module.exports = __webpack_public_path__ + "img/volume-mute.364a662f.svg";